import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';
import { UserService } from 'src/app/services/user.service';
import { UmOrganizationViewModalComponent } from 'src/app/um/um-organization/um-organization-view-modal/um-organization-view-modal.component';
import { BudgetTimelineConfigComponent } from '../budget-timeline-config/budget-timeline-config.component';

@Component({
  selector: 'app-admin-console',
  templateUrl: './admin-console.component.html',
  styleUrls: ['./admin-console.component.scss']
})
export class AdminConsoleComponent implements OnInit {
  userDetails: any = null;
  MenuList: any[] = [];
  OrgId: string = "";
  ISTConsole: any[] = [];
  EAPConsole: any[] = [];
  GRANTSConsole: any[] = [];
  AUDITLogConsole: any[] = [];
  GeneralConsole: any[] = [];
  ANALYTICSConsole: any[] = [];
  Ist_DisplayName = "";
  Eap_DisplayName = "";
  Grants_DisplayName = "";

  constructor(public modalService: NgbModal, private userService: UserService, private commonService: CommonService) { }

  ngOnInit(): void {
    this.userDetails = this.userService.getUserDetais();
    var ist = this.userDetails.FEATURES.filter(function (item) {
      return (item.Id == "istconsole")
    })[0];
    if (ist != null && ist != undefined) {
      this.Ist_DisplayName = ist.Name;
      this.ISTConsole = ist.Features;
    }
    let eap = this.userDetails.FEATURES.filter(function (item) {
      return (item.Id == "eapconsole")
    })[0];
    if (eap != null && eap != undefined) {
      this.Eap_DisplayName = eap.Name;
      this.EAPConsole = eap.Features;
    }
    let grant = this.userDetails.FEATURES.filter(function (item) {
      return (item.Id == "grantsconsole")
    })[0];
    if (grant != null && grant != undefined) {
      this.Grants_DisplayName = grant.Name;
      this.GRANTSConsole = grant.Features;
    }

    let auditlog = this.userDetails.FEATURES.filter(function (item) {
      return (item.Id == "auditlog")
    })[0];

    if (auditlog != null && auditlog != undefined) {
      this.AUDITLogConsole = auditlog.Features;
    }

    let analytics = this.userDetails.FEATURES.filter(function (item) {
      return (item.Id == "analyticsconsole")
    })[0];

    if (analytics != null && analytics != undefined) {
      this.ANALYTICSConsole = analytics.Features;
    }

    let um = this.userDetails.FEATURES.filter(function (item) {
      return (item.Id == "general")
    })[0];

    if (um != null && um != undefined) {
      this.GeneralConsole = um.Features;
    }
    this.OrgId = this.userService.getOrganizationId()
  }
  EditOrganization() {
    let modalRef = this.modalService.open(UmOrganizationViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'Edit',
      content: { id: this.OrgId }
    }
    modalRef.result.then((result) => {
      this['self'].getSummaryData();
    });
  }

  GetPermission(code: string) {
    let havPermission = this.GeneralConsole.filter(function (item) {
      return (item.Code == code)
    })[0];
    if (havPermission != null && havPermission != undefined) {
      return true;
    }
    else {
      return false;
    }

  }
  GetMainMenuPermission(codesList: any) {
    let hadPermission = false;
    codesList.forEach((itemCode) => {
      if (hadPermission == false) {
        let havPermission = this.GeneralConsole.filter(function (item) {
          return (item.Code == itemCode)
        })[0];
        if (havPermission != null && havPermission != undefined) {
          hadPermission = true;
        }
      }
    })
    return hadPermission;

  }


  TimelineConfiguration() {
    let modalRef = this.modalService.open(BudgetTimelineConfigComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'Edit',
      content: { id: this.OrgId }
    }
    modalRef.result.then((result) => {
      this['self'].getSummaryData();
    });
  }



}
